import $ from 'jquery'
import GameManager from '../GameManager';
import { GameDataConfig } from './interfaces';
import { toast } from 'react-toastify';
import { getSaveData } from '../../misc/tools';

/**
 * General helper methods
 */
export default class Tools {

	/**
	 * Call this for any divs' onKeyUp callback and it will make sure when enter is pressed it will act as a normal mouse click
	 */
	public static mapDivEnterToClick(args: any): void {
		if(args.key === 'Enter') {
			$(args.target as any).trigger('click');
		}
	}

	public static showToastNotification(msg: string) {
		toast(msg);
	}

	public static shuffle(array: any) {
		let currentIndex = array.length,  randomIndex;
	  
		// While there remain elements to shuffle.
		while (currentIndex != 0) {
	  
		  // Pick a remaining element.
		  randomIndex = Math.floor(Math.random() * currentIndex);
		  currentIndex--;
	  
		  // And swap it with the current element.
		  [array[currentIndex], array[randomIndex]] = [
			array[randomIndex], array[currentIndex]];
		}
	  
		return array;
	  }

	public static updateWindow = (windowToUse: string): void => {
		//setWindow(window);
		let url = new URL(window.location.href);
		let search_params = url.searchParams;
		
		search_params.set('w', windowToUse);

		url.search = search_params.toString();

		window.location.href = url.toString();
	}

	public static addOnColorSchemeChanged(onChanged: (isDarkMode: boolean) => void) : any {
		// const method = () => {
		// 	onChanged(this.isUsingDarkMode());
		// };
		// window.matchMedia('(prefers-color-scheme: dark)')
		// 	.addEventListener('change', method);

		// return method;
	}

	public static removeOnColorSchemeChanged(method: any) : void {
		// window.matchMedia('(prefers-color-scheme: dark)')
		// 	.removeEventListener('change', method);
	}

	public static isUsingDarkMode = (): boolean => {
		// return window.matchMedia('(prefers-color-scheme: dark)').matches;
		return false;
	}

	public static isTesting() {
		return (window as any)['core-unit-test'];
	}

	public static getGameManager(): GameManager {
		return (window as any)['core-gm'];
	}

	public static getSaveDataOrNull = (): GameDataConfig => {
		let savedDataRaw = localStorage.getItem('saved-game-jcdst');
		let savedData: GameDataConfig = null;
		if(savedDataRaw) {
			savedData = JSON.parse(savedDataRaw);
		} else {
			return null;
		}
	
		return savedData;
	}

	public static playOneShotSound = (url: string, onDone?: () => void): void => {
		const savedData = getSaveData()
		Tools.getGameManager().SoundManager.playSound({
			src: url,
			autoPlay: true,
			controls: false,
			enableClosedCaptioning: false,
			loop: false,
			muted: !savedData.isAudioEnabled,
			onEnded: onDone,
			oneShot: true,
			playsInline: true,
			volume: 1,
			pitch: 0
		})
	}

	public static forceRerenderUI = (uiName: string, instanceName?: string) => {
		if(!(window as any)[uiName]) {
			return undefined;
		}
		
		if(instanceName) {
			if(!(window as any)[uiName][instanceName]) {
				return undefined;
			}
			return (window as any)[uiName][instanceName]();
		}
	
		if(!(window as any)[uiName]['main']) {
			return undefined;
		}
		return (window as any)[uiName]['main']();
	}

	/**
	 * @returns True if the site is running in ios
	 */
	public static isios(): boolean{
		return [
			'iPad Simulator',
			'iPhone Simulator',
			'iPod Simulator',
			'iPad',
			'iPhone',
			'iPod'
		  ].includes(navigator.platform)
		  // iPad on iOS 13 detection
		  || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
	}

	/**
	 * True if in localhost
	 */
	public static isLocalhost(): boolean {
		return window.location.hostname === 'localhost';
	}

	/**
	 * True if the supplied string is a JSON string
	 * @param str The string to evaluate
	 */
	public static isJSON(str: string): boolean {
		return (str.startsWith('{') && str.endsWith('}')) || 
        ((str.startsWith('[') && str.endsWith(']')));
	}

	/**
	 * Generates a brand new guid
	 */
	public static generateGuid(): string {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
			let r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
			return v.toString(16);
		});
	}

	/**
	 * Generates a random integer between a minimum (included) and a maximum (included) number
	 * @param min The minimun to include
	 * @param max The maximum number to include
	 */
	public static  randomInteger(min: number, max: number) {
		return Math.floor(Math.random() * (max - min + 1)) + min;
	  }
	public static randomizeItemsInArray(array: any[]) {
		for (let i = array.length - 1; i > 0; i--) {
			let j = Math.floor(Math.random() * (i + 1));
			let temp = array[i];
			array[i] = array[j];
			array[j] = temp;
		}
	}
}
